import { render, staticRenderFns } from "./UserInvitesList.vue?vue&type=template&id=82c9f50e"
import script from "./UserInvitesList.vue?vue&type=script&lang=js"
export * from "./UserInvitesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports